import Modal from "app/pages/admin/components/Modal";
import React, { FC } from "react";
import RenderMedia from "../../Cognitive/components/RenderMidia";
import { QuizAnswerCognitiveType } from "interfaces";
import { Card, Title } from "app/pages/admin/components";
import Paragraph from "app/pages/admin/components/Paragraph";
import { useTheme } from "styled-components";
import { ThemeType } from "app/types/theme";

type ModalAnswerCognitiveProps = {
  answer: QuizAnswerCognitiveType;
  openModal: boolean;
  setOpenModal: (isOpen: boolean) => void;
  translate: any;
};

const ModalAnswerCognitive: FC<ModalAnswerCognitiveProps> = ({
  setOpenModal,
  openModal,
  answer,
  translate,
}) => {
  const theme: ThemeType = useTheme() as ThemeType;

  return (
    <Modal
      setShowModal={setOpenModal}
      showModal={openModal}
      style={{
        width: "80%",
        padding: "0",
        maxHeight: "600px",
        marginTop: "50px",
      }}
    >
      <Card
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "0",
          margin: "0",
        }}
      >
        <Card.Title>{translate("screenApp_results_answer_details")}</Card.Title>
        <Card.Body
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <Title
            style={{
              textAlign: "left",
              fontWeight: "normal",
              color: theme.secondaryText,
            }}
          >
            {translate("screenApp_results_answer_test")}: {answer.testResultId}
          </Title>
          <Paragraph>
            <Paragraph.Bold>
              {translate("screenApp_results_question")}:{" "}
            </Paragraph.Bold>
            {answer.question}
          </Paragraph>
          <Paragraph>
            <Paragraph.Bold>
              {translate("screens_quiz_labels_answer")}:
            </Paragraph.Bold>{" "}
            {answer.answer}
          </Paragraph>
          <Paragraph>
            <Paragraph.Bold>{translate("labels_home")}:</Paragraph.Bold>{" "}
            {new Date(answer.initDate).toLocaleString()}
          </Paragraph>
          <Paragraph>
            <Paragraph.Bold> {translate("labels_end")}:</Paragraph.Bold>{" "}
            {new Date(answer.endDateTime).toLocaleString()}
          </Paragraph>
          {answer.midiaUri && <RenderMedia mediaUri={answer.midiaUri} />}
        </Card.Body>
      </Card>
    </Modal>
  );
};

export default ModalAnswerCognitive;
